import { FileSpreadsheet, Play, Upload } from "lucide-react";
import { Badge, Button, Card } from "../components/ui";
import { DataTable } from "../components/DataTable";
import { useImportProfiles } from "../data/supergestor-data";

export function ImportCenterPage() {
  const query = useImportProfiles();
  return (
    <div className="page-stack">
      <div className="page-actions">
        <p>Upload → mapeamento → validação → duplicidades → dry run → aprovação → importação.</p>
        <Button>
          <Upload size={16} /> Nova importação
        </Button>
      </div>
      <Card
        title="Perfis de importação"
        description="Mapeamentos reutilizáveis para planilhas e sistemas antigos."
      >
        <DataTable
          rows={query.data ?? []}
          getKey={(row) => row.id}
          columns={[
            { key: "name", header: "Perfil", render: (row) => row.name },
            { key: "entity", header: "Destino", render: (row) => row.entityType },
            {
              key: "format",
              header: "Formato",
              render: (row) => <Badge tone="info">{row.format}</Badge>,
            },
            { key: "mappings", header: "Colunas", render: (row) => row.mappings },
            { key: "duplicates", header: "Duplicidade", render: (row) => row.duplicatePolicy },
            {
              key: "status",
              header: "Status",
              render: (row) => <Badge tone="success">{row.status}</Badge>,
            },
            {
              key: "action",
              header: "",
              render: () => (
                <Button variant="ghost">
                  <Play size={15} /> Dry run
                </Button>
              ),
            },
          ]}
        />
      </Card>
      <Card title="Migração rastreável">
        <div className="task-list">
          <div className="task-item">
            <FileSpreadsheet size={18} />
            <div>
              <strong>Rollback lógico</strong>
              <span>Cada entidade criada ou alterada possui snapshot de importação.</span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
